import * as z from "zod";

export const completeContextualOnboarding = {
  name: "completeContextualOnboarding" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
